@if (isLoading || isProcessing) {
  <div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
} @else {
  @if (!error && !showNoDataMessage) {
    <div class="canvas-container">
      <div class="canvas-block">
        <canvas
          baseChart
          height="290px;"
          width="100%"
          [datasets]="lineChartData"
          [labels]="lineChartLabels"
          [legend]="lineChartLegend"
          [options]="lineChartOptions"
          [type]="lineChartType"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked($event)"
          >
        </canvas>
      </div>
    </div>
  } @else {
    <div class="no-data-container">
      <div class="no-data-top">
        <fa-icon icon="chart-area" ></fa-icon> Engagement data coming soon!
      </div>
      <div>
        <a
          href="https://support.salesmail.com/portal/en/kb/articles/how-to-get-more-engagement-on-your-salesmail-videos"
          target="_blank"
          mat-button
          color="primary"
          >
          Click here to learn how to get more engagement!
        </a>
      </div>
    </div>
  }
  @if (error) {
    <p class="chartErrorText">{{ error }}</p>
  }
}

